import { Component, OnInit, ViewChild } from '@angular/core';
import { NzModalRef, NzMessageService, NzFormatEmitEvent, NzTreeNode } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FormControl} from '@angular/forms';
import {Observable, Observer} from 'rxjs';
import {ValidationErrors} from '@angular/forms';
import {RoleService, DeptService, UserService} from "@ecip/service";
import {CacheService} from "@delon/cache";

@Component({
  selector: 'app-user-local-edit',
  templateUrl: './edit.component.html'
})
export class UserLocalEditComponent implements OnInit {
  record: any = {};
  i: any;
  form: FormGroup;
  depts = [];
  deptId;
  // allRole = [{id:1, roleName: 'djsf'},{id:2, roleName: 'djsf'}];
  roleList = [];
  genderList = this.cacheService.get(`api/dict/type/sex`);

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public http: _HttpClient,
    private fb: FormBuilder,
    public deptService: DeptService,
    public roleService: RoleService,
    public userService: UserService,
    private cacheService: CacheService
  ) {}

  ngOnInit(): void {
    //è·åææç»ç»æºæ
    this.deptService.treeSelect().subscribe((res: any) => {
      let depts = [];
      res.forEach(item => {
        depts.push(new NzTreeNode({
          key: item.key,
          title: item.title,
          children: item.children,
          isLeaf: item.isLeaf,
          expanded: true
        }));
      });
      this.depts = depts;
    });
    this.roleService.getList().subscribe((res:any) => {
      this.roleList = res;
    });
    this.form = this.fb.group({
      deptId: [null, []],
      username: [null, [Validators.required],
        [UserLocalEditComponent.userNameAsyncValidator(this.userService, this.record.id)]],
      realName: [null, [Validators.required]],
      loginPwd: [null, [Validators.required, Validators.minLength(6)]],
      confirm: [null, [this.confirmValidator]],
      sex: [null, [Validators.required]],
      email: [null, [Validators.email]],
      roleIds: [null, []]
    });
    if (!this.record.id) {
      this.form.get('deptId').setValue(this.deptId);
      return;
    }
    let loginPwdCtl = this.form.get('loginPwd');
    loginPwdCtl.clearValidators();
    loginPwdCtl.setValidators(Validators.minLength(6));
    loginPwdCtl.updateValueAndValidity();

    Observable.forkJoin([this.userService.getById(this.record.id),
      this.userService.findRoleIds(this.record.id)]).subscribe(([user, roleIds]) => {
      this.form.patchValue(user);
      this.i = user;
      this.form.get('roleIds').setValue(roleIds);
      // this.form.get('sex').setValue("1");
    });
    /*this.userService.getById(this.record.id).subscribe(res => {
      this.form.patchValue(res);
      this.i = res;
    });*/
  }

  static userNameAsyncValidator(userService: UserService, id: string) {
    return (control: FormControl) => {
      return userService.checkAccount({account: control.value, id: id}).map(res => {
        return res ? null : { error: true, duplicated: true };
      });
    };
  }

  validateConfirmPassword(): void {
    setTimeout(() => this.form.controls.confirm.updateValueAndValidity());
  }

  confirmValidator = (control: FormControl): { [ s: string ]: boolean } => {
    if (!control.value) {
      if (this.form && this.form.controls.loginPwd.value) {
        return { required: true };
      }
      return { };
    } else if (control.value !== this.form.controls.loginPwd.value) {
      return { confirm: true, error: true };
    }
  };

  submit() {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) return;
    if (!this.record.id) {
      //æ°å¢
      this.userService.post(this.form.value).subscribe(res => {
        this.msgSrv.success('ä¿å­æå');
        this.modal.close(true);
      });
      return;
    }
    //ä¿®æ¹
    this.userService.put(this.record.id, this.form.value).subscribe(res => {
      this.msgSrv.success('ä¿å­æå');
      this.modal.close(true);
    });
  }

  close() {
    this.modal.destroy();
  }
}
